<app-loader [is_show_loader]="loader"></app-loader>

<div class="common-wrapper">
  <div class="base-scenario-wrapper common-width">
    <div class="scenario-controls">
      <div class="first-group">
        <h3 style="margin: 0px; justify-self: center">Create Base Scenario</h3>
        <div style="display: flex">
          <input
            matInput
            style="height: 24px"
            placeholder="Enter Scenario Name..."
            [(ngModel)]="scenarioName"
            placeholder="Enter Scenario Name"
            (change)="checkUniqueness($event)"
            value=""
            [ngStyle]="{
              background: 'default'
            }"
            [ngClass]="{
              error_input: !validName,
              normal_input: validName
            }"
          />

          <div
            *ngIf="!validName"
            style="
              color: red;
              white-space: pre;
              display: flex;
              align-items: center;
              margin-left: 4px;
            "
            class="validation"
          >
            Scenario already Exists
          </div>
        </div>

        <div>
          <!-- <button
            [disabled]="!scenarioName.length"
            mat-raised-button
            (click)="files.click()"
            color="primary"
          >
            Upload & Check Data
          </button> -->
        </div>
      </div>

      <div class="control">
        <!-- *ngIf="userType === usreConfig.MANG" -->
        <button
          [disabled]="!validName || !scenarioName.length"
          mat-raised-button
          (click)="discard()"
        >
          Discard
        </button>
        <button
          [disabled]="
            !validName ||
            !scenarioName.length ||
            !selectedVolume ||
            !selectedPrice ||
            !checkValidDate()
          "
          mat-raised-button
          (click)="createBaseScenario()"
          color="primary"
        >
          Next
        </button>
      </div>
    </div>
    <div class="scenario-checks">
      <div class="checks-container">
        <div class="consistency common-box">
          <div class="consistency-heading big-header-montserrat">
            <img
              src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
              alt=""
            />
            <span>
              User Inputs
              <mat-icon style="position: relative; top: 11px; font-size: 15px"
                >info</mat-icon
              >
            </span>
          </div>
          <mat-divider></mat-divider>
          <div style="padding: 20px">
            <div class="common-drop">
              <div class="key">Volume<span class="asterick">*</span></div>
              <mat-form-field appearance="outline">
                <mat-select
                  name="countryString"
                  [(value)]="selectedVolume"
                  placeholder="Volume"
                  [disabled]="!validName || !scenarioName.length"
                >
                  <mat-option
                    *ngFor="let option of volumeOptions"
                    [value]="option"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="common-drop">
              <div class="key">Category<span class="asterick">*</span></div>
              <mat-form-field appearance="outline">
                <mat-select
                  name="countryString"
                  [(value)]="selectedCategory"
                  placeholder="Category"
                  [disabled]="!validName || !scenarioName.length"
                >
                  <mat-option
                    *ngFor="let option of categoryOptions"
                    [disabled]="option.disabled"
                    [value]="option"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div class="common-drop">
              <div style="margin-right: 20px" class="key">
                Price Changes <span class="asterick">*</span>
              </div>

              <mat-form-field appearance="outline">
                <mat-select
                  name="countryString"
                  [(value)]="selectedPrice"
                  placeholder="Price Changes"
                  [disabled]="!validName || !scenarioName.length"
                  (selectionChange)="onPriceChange()"
                >
                  <mat-option
                    *ngFor="let option of priceOptions"
                    [value]="option"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <app-period-picker
                label="Start Date"
                [price]="selectedPrice"
                [currentlyAvailablePeriodData]="
                  currentlyAvailablePeriodData.start
                "
                (quarterChange)="onStartQuarterChange($event)"
                (yearChange)="onStartYearChange($event)"
                (monthChange)="onStartMonthChange($event)"
                (weekChange)="onStartWeekChange($event)"
              ></app-period-picker>

              <app-period-picker
                label="End Date"
                [price]="selectedPrice"
                [currentlyAvailablePeriodData]="
                  currentlyAvailablePeriodData.end
                "
                (quarterChange)="onEndQuarterChange($event)"
                (yearChange)="onEndYearChange($event)"
                (monthChange)="onEndMonthChange($event)"
                (weekChange)="onEndWeekChange($event)"
              ></app-period-picker>
            </div>
            <!-- <div class="duration-container">
              <div class="common-drop">
                <div style="margin-right: 23px" class="key">
                  Start Date <span class="asterick">*</span>
                </div>

                <mat-form-field appearance="outline">
                  <mat-select
                    name="countryString"
                    [(value)]="selectedStartDate"
                    placeholder=""
                    [disabled]="!validName || !scenarioName.length"
                  >
                    <mat-option
                      *ngFor="let option of timeIntervaloption"
                      [value]="option"
                      >{{ option }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="common-drop">
                <div style="margin-right: 23px" class="key">
                  End Date <span class="asterick">*</span>
                </div>

                <mat-form-field appearance="outline">
                  <mat-select
                    name="countryString"
                    [(value)]="selectedEndDate"
                    placeholder=""
                    [disabled]="!validName || !scenarioName.length"
                  >
                    <mat-option
                      *ngFor="let option of timeIntervaloption"
                      [value]="option"
                      >{{ option }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="common-drop">
                <div class="duration">Duration: <span> 48 Weeks</span></div>
              </div> -->
            <!-- </div> -->
          </div>
        </div>
        <!-- <div class="data-summary common-box">
          <div class="data-summary-heading big-header-montserrat">
            <img
              src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
              alt=""
            />
            <span> Data Summary </span>
          </div>
          <div class="data-summary-table-heading new-header">
            <div class="row" style="border-bottom: 1px solid #d0d2d3">
              <div class="item">Items</div>
              <div class="check">Check</div>
            </div>
          </div>
          <div class="data-summary-data data">
            <ng-container *ngFor="let obj of dataSummary">
              <div class="row">
                <div class="item normal-text-montserrat">{{ obj.item }}</div>
                <div class="check">{{ obj.value }}</div>
              </div>
            </ng-container>
          </div>
        </div> -->
      </div>
    </div>
    <div class="scenario-navigation">
      <button (click)="goBack()" mat-button>
        <mat-icon color="red" style="font-size: 20px"> arrow_back </mat-icon>
        <span> Go Back </span>
      </button>
      <button style="display: none" mat-raised-button color="primary">
        <img src="../../../assets/IMP PVP Tool Icons/download.svg" alt="" />
        <span> Download Template </span>
      </button>
    </div>
  </div>
</div>
